import React, { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useSelectedTenant } from "./SelectedTenantContext";
import { TenantDto } from "../../model/TenantDto";
import { useGetTenants } from "../../api/tenants/useTenants";

export const SelectTenant: React.FC = () => {
    const { selectedTenant, setSelectedTenant } = useSelectedTenant();
    const { loading, data, error, execute } = useGetTenants();
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const handleSelect = (tenant: TenantDto) => {
        setSelectedTenant(tenant);
        setIsOpen(false);
        setSearchTerm("");
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        if (!isOpen) setIsOpen(true);
    };

    if (loading || !data) {
        return <div>Loading</div>;
    }

    // Filter and sort the tenants
    const filteredTenants = data
        .filter(tenant =>
            tenant.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => a.title.localeCompare(b.title));

    return (
        <div className="d-flex justify-content-end">
            <Dropdown show={isOpen} onToggle={setIsOpen}>
                <Dropdown.Toggle
                    variant="outline-secondary"
                    id="dropdown-basic"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {selectedTenant?.title || "Select tenant"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <div className="px-3 py-2">
                        <Form.Control
                            type="text"
                            placeholder="Search tenants..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                    <Dropdown.Divider />
                    {filteredTenants.length > 0 ? (
                        filteredTenants.map((tenant) => (
                            <Dropdown.Item
                                key={tenant.id}
                                onClick={() => handleSelect(tenant)}
                            >
                                {tenant.title}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <Dropdown.Item disabled>
                            No tenants found
                        </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};